import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;
